import { render, staticRenderFns } from "./NeighbourhoodNavBtn.vue?vue&type=template&id=32acf47e&scoped=true&"
import script from "./NeighbourhoodNavBtn.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodNavBtn.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodNavBtn.vue?vue&type=style&index=0&id=32acf47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32acf47e",
  null
  
)

export default component.exports